function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import * as React from "react";
import { ContainerContext, createUseDataContainer } from "../DataContainer/container";
import { commonFields } from "../DataContainer/fields";
import { Logger } from "../utils/Logger";
import { createButton } from "./actions/Button";
import { createControlledForm, createForm } from "./utils/createForm";
var logger = new Logger("Form");
var defaultAdditionalLists = {};
export function useForm(data) {
  var additionalFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAdditionalLists;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- ContainerContext needs to be created only once!
  var context = React.useMemo(function () {
    return new ContainerContext(data);
  }, []);
  var formDataContainer = React.useMemo(function () {
    return createUseDataContainer(Object.assign(Object.assign({}, commonFields), additionalFields || {}), "useSubform")(context);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps -- AdditionFields cannot be changed during component lifecycle, otherwise we will disable inline assigning
  [context]);
  var setDataReference = React.useRef({});
  return React.useMemo(function () {
    return Object.assign(Object.assign({}, formDataContainer), {
      Button: createButton(context),
      setData: function setData(newData) {
        var _a;
        var currentData = context.getData();
        context.update(Object.assign(Object.assign({}, currentData), newData));
        if (!((_a = setDataReference.current) === null || _a === void 0 ? void 0 : _a.setData)) {
          logger.warn("Form must be rendered form before calling setData!");
        } else {
          setDataReference.current.setData(newData);
        }
      },
      Form: createForm(context, setDataReference)
    });
  }, [context, formDataContainer, setDataReference]);
}
export function useControlledForm() {
  var additionalFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultAdditionalLists;
  var context = React.useMemo(function () {
    return new ContainerContext({});
  }, []);
  var formDataContainer = React.useMemo(function () {
    return createUseDataContainer(Object.assign(Object.assign({}, commonFields), additionalFields || {}), "useSubform")(context);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps -- AdditionFields cannot be changed during component lifecycle, otherwise we will disable inline assigning
  [context]);
  return React.useMemo(function () {
    return Object.assign(Object.assign({}, formDataContainer), {
      Button: createButton(context),
      Form: createControlledForm(context)
    });
  }, [context, formDataContainer]);
}
// Helper function to extract types of useForm, this class is never actually initialized
var Helper = /*#__PURE__*/_createClass(function Helper() {
  _classCallCheck(this, Helper);
  this.useForm = useForm({});
  this.useControlledForm = useControlledForm();
});